module.exports = __webpack_public_path__ + "img/samsung-galaxy-book-s-4.4d617ae.jpg";